module.exports = __webpack_public_path__ + "img/mono_34.edad42e8.png";